export type TValidPdfReportNames =
  | 'Student Snapshot'
  | 'Regents Plan & Prep Report'
  | 'EMS Assessment Report'
  | 'Attendance Report';

export type TValidPdfReportKeys = 'snapshot' | 'emsAssessment' | 'regentsSched' | 'attendance';

interface IPdfReportTypes {
  snapshot: TValidPdfReportNames;
  emsAssessment: TValidPdfReportNames;
  regentsSched: TValidPdfReportNames;
  attendance: TValidPdfReportNames;
}

export const pdfReportTypes: IPdfReportTypes = {
  snapshot: 'Student Snapshot',
  regentsSched: 'Regents Plan & Prep Report',
  emsAssessment: 'EMS Assessment Report',
  attendance: 'Attendance Report',
};
